import { render, staticRenderFns } from "./upkeeptasklist.vue?vue&type=template&id=2c1adee2&scoped=true&"
import script from "./upkeeptasklist.vue?vue&type=script&lang=js&"
export * from "./upkeeptasklist.vue?vue&type=script&lang=js&"
import style0 from "./upkeeptasklist.vue?vue&type=style&index=0&id=2c1adee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1adee2",
  null
  
)

export default component.exports